import React, {useState} from 'react';
import Analytics from 'utils/Analytics';
import {enableDarkMode, overridePrefersColorScheme} from 'utils/darkMode';
import {growthBook} from 'utils/growthbook';
import styles from './DarkModeButton.module.css';

export const USER_DARK_MODE_KEY = 'user_dark_mode';

export const setDarkModeForUserPreference = () => {
  const web_ex44_user_dark_mode_button = growthBook.getFeatureValue('web_ex44_user_dark_mode_button', false);
  if (!web_ex44_user_dark_mode_button) {
    return null;
  }
  const darkMode = JSON.parse(localStorage.getItem(USER_DARK_MODE_KEY) ?? 'false');
  enableDarkMode(darkMode);
};

const DarkModeButton: React.FC = () => {
  const [darkMode, setDarkMode] = useState(JSON.parse(localStorage.getItem(USER_DARK_MODE_KEY) ?? 'false'));
  const showLabel = true;

  const toggleTheme = () => {
    const newState = !darkMode;

    Analytics.track(`User toggled dark mode ${newState ? 'ON' : 'OFF'} `);
    Analytics.identify({
      dark_mode: newState ? 'enabled' : 'disabled',
    });
    overridePrefersColorScheme(newState);
    enableDarkMode(newState);
    localStorage.setItem(USER_DARK_MODE_KEY, newState.toString());
    setDarkMode(newState);
  };

  return (
    <div
      onClick={toggleTheme}
      className={`${styles.button} ${showLabel ? styles.buttonExpanded : styles.buttonCollapsed}`}
      data-theme={darkMode ? 'light' : 'dark'}
      title={`Switch to ${darkMode ? 'light' : 'dark'} mode`}
    >
      <div className={`${styles.label} ${showLabel ? styles.labelVisible : styles.labelHidden}`}>
        {!darkMode ? 'Dark' : 'Light'}
      </div>
      <div className={styles.icon}>{!darkMode ? '🌙' : '☀️'}</div>
    </div>
  );
};

export default DarkModeButton;
